import React from "react";

function RecruitmentSetReminder() {
  return (
    <div className="bg-[#E1F7FF] px-6 py-4 flex flex-col gap-4 rounded-2xl">
      <div>
        <p className="text-[#033F6A] text-xl font-semibold">
          Đặt lời nhắc công việc
        </p>
        <p className="mt-2 text-[#606060] font-normal">
          Nhập địa chỉ email của bạn và nhận thông báo việc làm.
        </p>
      </div>
      <input
        placeholder="Email của bạn"
        className="bg-white px-4 py-[10px] rounded-lg"
      />
      <button
        onClick={() => {}}
        className="bg-[#1C9BDB] rounded-2xl text-white px-7 w-[137px] h-11"
      >
        Xác nhận
      </button>
    </div>
  );
}

export default React.memo(RecruitmentSetReminder);
